import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { getApiEndpoint } from '../../../config/api';
import { getAuthHeader } from '../../../utils/auth';
import './AddClientModal.css';

const AddClientModal = ({ isOpen, onClose, onCreated }) => {
  const [tab, setTab] = useState('invite');
  const [form, setForm] = useState({ email: '', name: '', company_name: '' });
  const [busy, setBusy] = useState(false);

  if (!isOpen) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email.trim()) return toast.error('Email is required');
    setBusy(true);
    try {
      const body = tab === 'invite'
        ? { new_client: { email: form.email.trim(), name: form.name.trim(), company_name: form.company_name.trim() } }
        : { new_client: { email: form.email.trim() } };
      const r = await fetch(getApiEndpoint('/api/fm/clients'), {
        method: 'POST',
        headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!r.ok && r.status !== 202) throw new Error();
      toast.success(tab === 'invite' ? 'Invite sent — client added' : 'Client linked');
      setForm({ email: '', name: '', company_name: '' });
      onCreated && onCreated();
    } catch (_) {
      toast.error('Could not add client');
    } finally { setBusy(false); }
  };

  return (
    <div className="cs-acm-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="cs-acm-modal" onClick={e => e.stopPropagation()}>
        <div className="cs-acm-header">
          <h3>Add a client</h3>
          <button type="button" className="cs-acm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="cs-acm-tabs">
          <button
            type="button"
            className={`cs-acm-tab ${tab === 'invite' ? 'active' : ''}`}
            onClick={() => setTab('invite')}
          >Invite new client</button>
          <button
            type="button"
            className={`cs-acm-tab ${tab === 'link' ? 'active' : ''}`}
            onClick={() => setTab('link')}
          >Link existing</button>
        </div>

        <form onSubmit={submit} className="cs-acm-form">
          <label>
            Email
            <input
              type="email"
              required
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              placeholder="client@example.com"
            />
          </label>
          {tab === 'invite' && (
            <>
              <label>
                Contact name
                <input
                  type="text"
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  placeholder="Jane Smith"
                />
              </label>
              <label>
                Company name
                <input
                  type="text"
                  value={form.company_name}
                  onChange={e => setForm({ ...form, company_name: e.target.value })}
                  placeholder="Acme Holdings Ltd"
                />
              </label>
              <p className="cs-acm-note">An invite email will be sent (transport pending). The client account is created in pending state.</p>
            </>
          )}
          {tab === 'link' && (
            <p className="cs-acm-note">If a CloudSafe user with this email already exists, they will be linked to your FM company. Otherwise nothing happens.</p>
          )}
          <div className="cs-acm-actions">
            <button type="button" className="cs-acm-secondary" onClick={onClose} disabled={busy}>Cancel</button>
            <button type="submit" className="cs-acm-primary" disabled={busy}>
              {busy ? 'Working…' : (tab === 'invite' ? 'Invite client' : 'Link client')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClientModal;
